export function detectWebGLSupport(): boolean {
    if (!window || !window.WebGLRenderingContext) {
        console.log('[WebGL] WebGLRenderingContext not found. Using canvas layers instead.');
        return false;
    }

    try {
        const canvas = document.createElement('canvas');
        const gl = (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')) as WebGLRenderingContext;

        if (!gl) {
            console.log('[WebGL] WebGLRenderingContext not found. Using canvas layers instead.');
            return false;
        }

        // Check if hardware acceleration is disabled
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
            const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) as string;
            // Detect software renderers
            if (
                renderer.includes('SwiftShader') ||
                renderer.includes('Software') ||
                renderer.includes('Microsoft Basic')
            ) {
                console.log('[WebGL] Hardware acceleration is disabled, using software renderer:', renderer);
                return false;
            }
        }

        // Check basic WebGL capabilities
        const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE) as number;
        if (maxTextureSize < 2048) {
            console.log('[WebGL] MAX_TEXTURE_SIZE is too small:', maxTextureSize);
            return false;
        }

        return true;
    } catch (e) {
        console.log('[WebGL] Detection error:', e);
        return false;
    }
}
